// extracted by mini-css-extract-plugin
export default {"lawPartners":"responsiveStyles_lawPartners__hkeM7","fourPoints":"responsiveStyles_fourPoints__O00+m"};